
import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {
export class LuckySeven_Responsive extends SlotGameType1_Responsive {


    protected override helpFactory: IHelpFactory = new LuckySevenHelpFactory();
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "LuckySeven");

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }
    //SEND COLOR FOR RSA 
    protected override color: RewardColor =
        {
            color: "#F1F0C9",
            coloroutherStroke: "black",
            colorinnerStroke: "#9F8DF4",
        }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/Wild Nature.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // }

    protected override colorLineMarkers: MarkersInfoColors =
        {
            MarkerbackgroundColor: "linear-gradient(90deg, rgb(0,0,0),rgb(84,4,140),rgb(84,4,140),rgb(0,0,0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

}
//Help Colorized
class LuckySevenHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LuckySevenHelp(params);
    }
}

class LuckySevenHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(0,0,0),rgb(84,4,140),rgb(84,4,140),rgb(0,0,0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
// }